import React from 'react';
import $ from 'jquery';
import classnames from 'classnames';

class ScholarshipContent extends React.Component {

	downloadApp = () => {
		console.log("here I am");
		$.get('/scholarship.pdf',()=>{});
	};

	render(){

		return (
			<div className="scholarship-main">
		     	<div className="container">
				 <div className="offset"></div>
			      	<div className="row">
				        <h1 className="title">Introduction and Purpose of the Scholarships</h1>
				        <p>
				        The purpose of the Walter M. Cunningham Education Foundation Scholarship is to provide students with an incentive
				        to continue and complete their formal education in the field of Surveying and Mapping.
				        </p>
				        <div className="container">
					        <div className="row">
						        <div className="col-md-6 col-sm-12">
							        <h3>Prioritized Selection Criteria</h3>
							        <ol className="scholarship-list">
							        	<li>level of academic achievement</li>
							        	<li>financial need</li>
							        	<li>the quality of employment within a company that is presently engaged <br />in the practice of Land Surveying, GIS, or Geomatics</li>
							        	<li>the quality of the letters of recommendation received</li>
							        	<li>the quality and applicability of the applicant’s statement of education<br />and career goals regarding Land Surveying, GIS, or Geomatics</li>
							        </ol>
						        </div>
						        <div className="col-md-6 col-sm-12">
						        	<div className="scholarship-box">
										<a href={require('../scholarship.pdf')} onClick={this.downloadApp} className="button application-button">Download Application</a>
				        			</div>
				        			<div className="scholarship-address">
				        				<p>Send completed scholarship applications to:</p>
				        				<div className="address-box">
				        					<center>The Walter M. Cunningham Education Foundation</center>
											<center>P.O. Box 1032</center>
											<center>Salt Lake City, UT  84110</center>
										</div>
										<p>or email to:</p>
										<div className="address-box">
											<center><a href="mailto:susan@wmcef.org">susan@wmcef.org</a></center>
										</div>
									</div>
						        </div>
					        </div>
							<div className={classnames("row", "awards-row")}>
								<a href={require('../scholarship-awards.pdf')} className="button">View 2023 Scholarship Awards</a>
							</div>
				        </div>
			      	</div>
			    </div>
		    </div>
	    )
	}
};

export default ScholarshipContent;



// WEBPACK FOOTER //
// ./src/components/ScholarshipContent.js